<template>
    <v-dialog
        v-model="showTemplateDialog"
        :title="configData.popup_title"
        class="app-template-dialog"
    >
        <div class="app-template-subtit">
            {{ configData.popup_subtitle }}
        </div>
        <div class="app-template-list">
            <div
                v-for="item in configData.items"
                :key="item.suite_id"
                :class="selectedId === item.suite_id ? 'app-template-item-selected' : ''"
                @click="selectTemplate(item)"
                class="app-template-item"
            >
                <div class="app-template-item-tit">
                    {{ item.name }}
                </div>
                <div class="app-template-item-desc">
                    {{ item.describe }}
                </div>
                <div class="app-template-item-img">
                    <img
                        :src="item.picture"
                        class="app-template-item-image"
                    >
                </div>
            </div>
        </div>
        <v-button
            @click="installConfirm"
            status="primary"
            size="large"
            class="app-template-btn"
        >
            安装应用
        </v-button>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            selectedItem: {},
            showTemplateDialog: false,
            configData: {},
        };
    },

    computed: {
        selectedId() {
            return this.selectedItem && this.selectedItem.suite_id;
        },
    },

    methods: {
        show(data) {
            this.configData = data || {};
            this.selectedItem =  {};
            if (data && data.item) {
                this.selectedItem = data.items[0] || {};
            }
            this.showTemplateDialog = true;
        },

        selectTemplate(item) {
            this.selectedItem = item;
        },

        installConfirm() {
            if (!this.selectedId) {
                this.$message.error('请选择要安装的应用');
                return;
            }

            const { name, suite_id } = this.selectedItem || {};
            if (suite_id.startsWith('dk')) {
                this.$router.push({ path: '/mng/weworkAccount/index/instead', query: { suiteId: suite_id } });
            } else {
                this.$confirm({
                    title: `选择“${name}”并授权安装应用？`,
                    content: '应用安装后不可修改咨询方式，如需修改请联系售后处理',
                    confirmText: '安装应用',
                    confirm: () => {
                        this.$emit('install', this.selectedItem);
                    },
                });
            }
        },
    },
};
</script>
<style lang="less">
@import './app-install-template.less';
.app-template-dialog {
    .v-dialog__content {
        min-width: 1107px;
    }
}
</style>
